class NmsQuickAdd extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(event) {
    if (!window.fetch || !window.Shopify || !window.Shopify.routes) return;
    event.preventDefault();
    const button = this.form.querySelector('[type="submit"]');
    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.form)
      });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(`${window.Shopify.routes.root}cart`);
    } catch (error) {
      this.form.submit();
    } finally {
      button.disabled = false;
    }
  }
}

if (!customElements.get('nms-quick-add')) customElements.define('nms-quick-add', NmsQuickAdd);

